/* eslint-disable react/display-name */
import { navigate } from 'gatsby';

const createRedirect =
  (to = '/'): (() => JSX.Element | null) =>
  () => {
    if (typeof window !== 'undefined') {
      navigate(to) as unknown as void;
    }
    return null;
  };

export default createRedirect;
